import { InjectionToken } from '@angular/core';

export interface IAiSuiteConfig {
  demoBookingUrl: string;
}

export const AI_SUITE_CONFIG = new InjectionToken<IAiSuiteConfig>(
  'AI_SUITE_CONFIG'
);
